module.exports = __webpack_public_path__ + "icon_alert_no_data_new.9ad0b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/_asset/sources/assets/images/@svg/icon_alert_no_data_new.svg
// module id = ./src/_asset/sources/assets/images/@svg/icon_alert_no_data_new.svg
// module chunks = main